import type { CopyShape } from "@tami/core/intl";

import type { FINANCE_SCRIPT_COPY_PT_BR } from "../finance-script.copy";

export const FINANCE_SCRIPT_COPY_ES_ES: CopyShape<typeof FINANCE_SCRIPT_COPY_PT_BR> = {
  finIntro: {
    narrative:
      "Finanzas del creator: entiende cuánto ha entrado, cuánto ha salido y lo que te queda por cobrar — sin hojas de cálculo a mano.",
  },
  finMain: {
    narrative: "Los ingresos de campañas entran automáticamente en finanzas. Mira todo lo que ha entrado y salido este mes.",
    callout: "Todo lo que ha entrado, lo que te queda en el bolsillo y el margen — de un vistazo.",
  },
  finOverview1: {
    narrative: "Organiza las fechas de pago y de cobro sin perder ni una factura.",
  },
  finInvoicesOpen: {
    narrative: "¡Ojo con esto! Abre la gestión y mira cada entrada y salida del mes en una tabla clara.",
    callout: "Tu pasta, bajo control — busca, exporta y sigue todas tus facturas.",
  },
  finInvoicesTable: {
    narrative: "Campañas, gastos e ingresos sueltos — todo con tipo, vencimiento y estado pendiente o pagado.",
    callout: "Cada fila muestra de dónde viene, cuánto ha sido y si ya ha llegado a tu cuenta.",
  },
  finInvoicesStatus: {
    narrative: "Márcalo como pagado o edítalo cuando haga falta — control total sobre lo que sigue pendiente.",
    callout: "Estado y plazos a la vista — nada se te escapa al cerrar el mes.",
  },
  finNewInvoiceOpen: {
    narrative: "Apunta un ingreso o un gasto nuevo en segundos — sin salir del panel de finanzas.",
    callout: "Nuevo ingreso o gasto — un flujo rápido para registrar cualquier movimiento.",
  },
  finNewInvoiceDesc: {
    narrative: "Describe el movimiento: honorarios, material, un café o cualquier otro gasto del día.",
    callout: "Ponle nombre a la entrada — así la encuentras fácil después en la gestión de facturas.",
  },
  finNewInvoiceMeta: {
    narrative: "¿Has cobrado o gastado? ¿Pago único o a plazos? La fecha y el tipo definen cómo entra en el informe.",
    callout: "Tipo, frecuencia y fecha — Tãmi organiza entradas y salidas automáticamente.",
  },
  finNewInvoiceAmount: {
    narrative: "Indica el importe y guarda — el movimiento entra en la gestión y en los gráficos del mes.",
    callout: "Cuánto ha entrado o salido — un clic y listo, sin hojas de cálculo.",
  },
  finDetailed: {
    narrative: "Gastos, ticket medio y ROI de campaña — números que te ayudan a cobrar y negociar mejor.",
    callout: "Descubre tu ticket medio, tu ROI y lo que sigue pendiente de pago.",
  },
  finOverview2: {
    narrative: "Revisar las facturas del mes y darle el check a cada movimiento se vuelve sencillo.",
  },
  finChartPlatform: {
    narrative: "Instagram, TikTok o YouTube — descubre qué red ha concentrado más ingresos en el periodo.",
    callout: "Ingresos por plataforma: mira dónde tu audiencia se convierte más en pasta.",
  },
  finChartType: {
    narrative: "Reels, stories o vídeo largo — compara formatos e invierte en lo que más rinde.",
    callout: "Tipo de contenido vs. facturación — datos para priorizar qué producir.",
  },
  finChartBrands: {
    narrative: "Descubre qué marcas han invertido más en ti — útil para renovar colaboraciones y fijar precios.",
    callout: "Ranking de marcas por ingresos — un historial claro para negociar la próxima campaña.",
  },
};
